import Select, { components, SingleValue } from 'react-select';

import './SearchSelect.scss';

import { SelectOptionT } from 'types';

import { stylesSelect } from './styles';

import NoDataIcon from 'assets/images/no-data2.png';
import ArrowIcon from 'assets/images/dropdown-arrow.svg';
import SearchIcon from 'assets/images/search.svg';

type DropdownIndicatorPropsT = {
  isFocused: boolean;
  selectProps: {
    menuIsOpen: boolean;
  };
};
const DropdownIndicator = (props: DropdownIndicatorPropsT) => {
  const {
    selectProps: { menuIsOpen },
  } = props;
  return (
    // @ts-ignore
    <components.DropdownIndicator {...props}>
      <img src={menuIsOpen ? SearchIcon : ArrowIcon} alt="InfoIcon" />
    </components.DropdownIndicator>
  );
};

const Menu = (props: any) => {
  return (
    // @ts-ignore
    <components.Menu {...props} className="search-select-menu" />
  );
};

type OptionPropsT = {
  label: string;
};
const Option = (props: OptionPropsT) => {
  const { label } = props;
  return (
    // @ts-ignore
    <components.Option {...props}>
      <span>{label}</span>
    </components.Option>
  );
};

const NoOptionsMessage = (props: any) => {
  return (
    // @ts-ignore
    <components.NoOptionsMessage {...props}>
      <span>
        <img src={NoDataIcon} alt="noOptionsMessage" />
      </span>
    </components.NoOptionsMessage>
  );
};

type SearchSelectT = {
  onChange: Function;
  name: string;
  value: SelectOptionT | null;
  isDisabled?: boolean;
  placeholder: string;
  options: SelectOptionT[];
};

const SearchSelect = ({ onChange, name, value, isDisabled = false, placeholder, options }: SearchSelectT) => {
  const changeHandler = (option: SingleValue<SelectOptionT>) => {
    if (option && value && option.value !== value.value) {
      onChange(option);
    }
  };

  const filterOptions = (option: SelectOptionT, inputValue: string) => {
    const whitespacesRegEx = /\s+/g;
    const optionLabelStr = option.label.toLowerCase().replace(whitespacesRegEx, '');
    const optionValueStr = option.value.toLowerCase().replace(whitespacesRegEx, '');
    const inputValueStr = inputValue.toLocaleLowerCase().replace(whitespacesRegEx, '');

    if (optionLabelStr.includes(inputValueStr) || optionValueStr.includes(inputValueStr)) {
      return true;
    }
    return false;
  };

  return (
    <div className="search-select">
      <Select
        isDisabled={isDisabled}
        isSearchable={true}
        blurInputOnSelect={true}
        components={{ Menu, Option, DropdownIndicator, NoOptionsMessage, IndicatorSeparator: () => null }}
        filterOption={(o, v) => filterOptions(o, v)}
        name={name}
        defaultValue={{ value: '', label: '' }}
        value={value}
        options={options}
        onChange={changeHandler}
        styles={{ ...stylesSelect }}
        placeholder={placeholder ? placeholder : ''}
      />
    </div>
  );
};

export default SearchSelect;
